import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';
import axios from 'axios';

import firebase from "../firebase/FirebaseProvider";
import { withRouter } from 'react-router';
import './signup.css';

import { isPasswordValid, isEmailValid } from '../utils/regex'
import SecureAxiosClient from '../auth/secure_axios';
import getConfig from '../config';

const EMAIL_ALREADY_IN_USE_ERROR_CODE = "auth/email-already-in-use";

class Signup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isPasswordValid: false,
      isEmailValid: false,
      isEmailAlreadyInUse: false,
      password: "",
      email: ""
    };

    this.handleSignup = this.handleSignup.bind(this);
    this.handleNameUpdate = this.handleNameUpdate.bind(this);
    this.handleEmailUpdate = this.handleEmailUpdate.bind(this);
    this.handlePasswordUpdate = this.handlePasswordUpdate.bind(this);
    this.handlePasswordValid = this.handlePasswordValid.bind(this);
    this.handleSignup = this.handleSignup.bind(this);
    this.updateUserDetail = this.updateUserDetail.bind(this);
    this.recordInteraction = this.recordInteraction.bind(this);
  }

  handleEmailUpdate(event) {
    this.setState({ email: event.target.value });
  }

  handleNameUpdate(event) {
    this.setState({ name: event.target.value });
  }

  handlePasswordUpdate(event) {
    this.setState({ password: event.target.value });
    this.handlePasswordValid();
  }
  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.handleSignup(e);
    }
  }

  recordInteraction(user_id) {
    const config = getConfig();
    const url = config.bowser.domain + config.bowser.services.interaction;
    const data = { user_id, item_id: 'home-page' };

    axios.post(
      url,
      data
    ).then(resp => {
      console.log('interaction recorded:', resp);
    }).catch(err => console.log(err));
  }

  updateUserDetail(user) {
    console.log("inside updated user:", user)
    const config = getConfig();
    const updateUserUrl = `${config.luigi.domain}${config.luigi.services.user_create}`;
    new SecureAxiosClient(true).post(
      updateUserUrl,
      user,
      (responseCode, responseData) => {
        console.log("User Updated", responseData);
      }
    );
  }

  handleSignup(e) {
    e.preventDefault();
    this.verifyEmailPassword();
    const isPasswordValid = this.handlePasswordValid();
    if (isPasswordValid) {
      console.log("inside is password valid")
      const { name, email, password } = this.state;
      ReactGA.event({
        category: 'Login',
        action: 'Email Signup Initiated',
        label: email
      });
      const self = this;
      firebase.auth().createUserWithEmailAndPassword(email, password)
        .then(async () => {
          const user = firebase.auth().currentUser;
          await user.updateProfile({
            displayName: name
          });
          this.recordInteraction(user.uid);
          this.updateUserDetail(
            { name, image_url: user.photoURL }
          );
        })
        .then(userUpdated => {
          document.getElementById('credential-form').reset();
          // alert("Login successful for user: "+JSON.stringify(user));
          self.props.history.push("/verify-email");
        })
        .catch(err => {
          const errorMsg = JSON.stringify(err);
          ReactGA.event({
            category: 'Login',
            action: 'Email Signup Success',
            label: errorMsg,
            value: err.code
          });

          if (err.code == EMAIL_ALREADY_IN_USE_ERROR_CODE) {
            this.setState({ isEmailAlreadyInUse: true });
          } else {
            this.setState({ isEmailAlreadyInUse: false });
            alert('Something went wrong while signing up. Please try again later.');
          }
          console.log(err);
        });
    }
  }

  verifyEmailPassword() {
    const isValid = isEmailValid(this.state.email);
    if (!isValid) {
      this.setState({ isEmailAlreadyInUse: false });
    }
    this.setState({ isEmailValid: isValid });
    if (this.state.email === "" || this.state.password === "") {
      alert("Email and Password are required");
      this.setState({ isEmailAlreadyInUse: false });
      return;
    }
  }

  handlePasswordValid() {
    const isValid = isPasswordValid(this.state.password);
    this.setState({ isPasswordValid: isValid });
    return isValid;
  }

  render() {
    ReactGA.pageview('/sign-up');
    return (
      <div className="login-form">
        <h1>Sign up</h1>
        <form id='credential-form'>
          <input type="text" placeholder="Enter Name" value={this.state.name} onChange={this.handleNameUpdate} />
          <input type="text" placeholder="Email" value={this.state.email} onChange={this.handleEmailUpdate} />
          <input type="password" placeholder="Password" value={this.state.password} onChange={this.handlePasswordUpdate} onKeyDown={this.handleKeyDown} />
        </form>

        <div className='action-buttons'>
          <form onSubmit={this.handleSignup} id='signup-form'>
            <input type="submit" value="Signup" />
          </form>
        </div>
        {(!this.state.isPasswordValid && this.state.password.length > 0) && <div>Password doesn't meet minimum requirement. Make sure password is minimum 8 characters with both lower/uppercase, number and symbol.</div>}
        {(!this.state.isEmailValid && this.state.email.length > 0) && <div>Email address is invalid.</div>}
        {(this.state.isEmailAlreadyInUse && this.state.email.length > 0) && <div>Email address is already in use.</div>}
      </div>
    )
  }
}

export default withRouter(Signup);
